import { Action, ActionReducer, MetaReducer } from '@ngrx/store';

import { clearErrorOnSuccessMetaReducer } from './meta-reducer-clear-error.reducer';

import {
  AUTHENTICATION_FEATURE_KEY,
  AUTHORIZATION_FEATURE_KEY,
  AuthorizationState,
  logout,
  State,
} from '@elite/authentication/domain';

import { OPERATION_AREAS_FEATURE_KEY, State as OperationAreaState } from '@elite/operation-areas/api';

import { CARS_FEATURE_KEY, CarsState } from '@elite/car/domain';

import { RideAlertState } from '@elite/ride/api';

export function logoutMetaReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state: AppState | undefined, action: Action): AppState {
    if (action.type === logout.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}
/**
 * Order matters only in that both are pure wrappers: `logoutMetaReducer` blanks the tree before
 * the reducer runs, `clearErrorOnSuccessMetaReducer` reads what the reducer returned.
 */
export const metaReducers: MetaReducer<AppState>[] = [logoutMetaReducer, clearErrorOnSuccessMetaReducer];

interface AppState {
  router: unknown;
  [AUTHENTICATION_FEATURE_KEY]: State;
  [AUTHORIZATION_FEATURE_KEY]: AuthorizationState;
  [OPERATION_AREAS_FEATURE_KEY]: OperationAreaState;
  [CARS_FEATURE_KEY]: CarsState;
  rideAlerts: RideAlertState;
}
